import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Mic, Crown, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SongCard } from "@/components/SongCard";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";

export default function Record() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [songs, setSongs] = useState([]);
  const [usage, setUsage] = useState(null);

  useEffect(() => { api.get("/me/usage").then(({ data }) => setUsage(data)); }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/songs", { params: { q, limit: 18 } }).then(({ data }) => setSongs(data.items));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-full bg-neon-pink flex items-center justify-center glow-pink"><Mic className="w-6 h-6" /></div>
        <h1 className="font-head text-4xl font-black tracking-tighter">Choose a song to sing</h1>
      </div>

      {usage && (
        <div className={`mb-8 rounded-2xl p-4 flex items-center justify-between gap-4 ${usage.premium ? "bg-neon-purple/15 border border-neon-purple/30" : usage.free_recordings_remaining > 0 ? "glass" : "bg-neon-pink/15 border border-neon-pink/40"}`} data-testid="usage-banner">
          <p className="text-sm font-semibold flex items-center gap-2">
            {usage.premium ? <><Crown className="w-4 h-4 text-neon-purple" /> Premium — unlimited recordings</>
              : usage.free_recordings_remaining > 0 ? <><Sparkles className="w-4 h-4 text-neon-cyan" /> {usage.free_recordings_remaining} free recording{usage.free_recordings_remaining > 1 ? "s" : ""} remaining</>
              : "Free recording limit reached — Upgrade to Premium"}
          </p>
          {!usage.premium && <Link to="/premium" className="text-sm font-bold text-neon-pink whitespace-nowrap" data-testid="usage-upgrade">Go Premium →</Link>}
        </div>
      )}

      <div className="relative mb-8 max-w-xl">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search songs..." data-testid="record-search" className="pl-12 h-14 bg-input border-white/10 rounded-full" />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {songs.map((s, i) => (
          <button key={s.song_id} onClick={() => nav(`/studio/${s.song_id}`)} className="text-left" data-testid={`record-song-${s.song_id}`}>
            <SongCard song={s} index={i} />
          </button>
        ))}
      </div>
    </div>
  );
}
